import usePluginEntities from "./usePluginEntities";
const defaultResponse = {
  data: {
    valid: false,
    expired: false,
    violated: false
  },
  isInitialLoading: false,
  refetch: () => {
  }
};
const usePluggableLicenseCheck = (licenseType) => {
  var _a, _b;
  const pluggableLicenseCheck = usePluginEntities("licenseCheck");
  return (_b = (_a = pluggableLicenseCheck == null ? void 0 : pluggableLicenseCheck[0]) == null ? void 0 : _a.call(pluggableLicenseCheck, licenseType)) != null ? _b : defaultResponse;
};
export default usePluggableLicenseCheck;
